import { gql } from '@apollo/client';
import React from 'react';
import { createContext } from 'react';
import { ShopLocationContextFragment } from './__generated__/ShopLocationsContext.generated';

export const ShopLocationContext = createContext<{
  shopLocations: ShopLocationContextFragment[];
  isLoadingLocations: boolean;
}>({
  shopLocations: [],
  isLoadingLocations: false,
});

export function useShopLocationsContext() {
  return React.useContext(ShopLocationContext);
}

const fragment = gql`
  fragment ShopLocationContext on ShopLocation {
    id
    name
  }
`;
